import { ActionTypes, Actions } from "~/types/legal";
import { ReduxState } from "~/types/redux";
import merge from "lodash/merge";
import { normalizeLegalKey } from "~/redux/actions/legal";
const legal = (state: ReduxState, action: Actions): ReduxState => {
  switch (action.type) {
    case ActionTypes.SET_LEGAL_MAP:
      return merge({}, state, {
        legal: {
          ...state.legal,
          legalMap: action.legalMap
        }
      });
    case ActionTypes.ADD_ACTIVE_LEGAL:
      const normalizedLegal = action.activeLegal.map(normalizeLegalKey).filter((key, index, self) => self.indexOf(key) === index);
      const currentActiveLegal = state.legal?.activeLegal ?? [];
      const legalMap = state.legal?.legalMap ?? {};

      // Filter out legal keys that are already in the array OR have the same text as an existing key
      const nonDuplicates = normalizedLegal.filter(newKey => {
        if (currentActiveLegal.includes(newKey)) {
          return false;
        }
        const newLegalText = legalMap[newKey]?.text;
        if (!newLegalText) {
          return true;
        }
        const hasDuplicateText = currentActiveLegal.some(existingKey => {
          return legalMap[existingKey]?.text === newLegalText;
        });
        return !hasDuplicateText;
      });
      if (nonDuplicates.length === 0) return state;
      return merge({}, state, {
        legal: {
          ...state.legal,
          activeLegal: [...currentActiveLegal, ...nonDuplicates]
        }
      });
    case ActionTypes.RESET_ACTIVE_LEGAL:
      return {
        ...state,
        legal: {
          ...state.legal,
          activeLegal: []
        }
      };
    case ActionTypes.ADD_VIEWED_PRODUCT:
      const currentViewedProducts = state.viewedProducts ?? [];
      if (!currentViewedProducts.includes(action.productId)) {
        return {
          ...state,
          viewedProducts: [...currentViewedProducts, action.productId]
        };
      }
      return state;
    case ActionTypes.RESET_VIEWED_PRODUCTS:
      return {
        ...state,
        viewedProducts: []
      };
    default:
      return state;
  }
};
export default legal;